export default "__VITE_ASSET__249ea8c3__"